import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.parse-int.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";

/**
 *  Pull out a number array for the indexes in the path
 *  The key for:
 *     props.children.50.props.children.0.props.children.10.props.children.1
 *  Would be:
 *     [50,0,10,1]
 */
var getNodePathKey = function getNodePathKey(nodePath) {
  return _toConsumableArray(nodePath.matchAll(/\d+/g)).map(function (i) {
    return Number.parseInt(i[0], 10);
  });
};
/**
 * Will determine which node comes earlier in the tree. This will allow you sort a list of node paths or set list of objects containing node paths.
 * @param a {string} Node Path A, the { path } value from NodeContext
 * @param b {string} Node Path B, the { path } value from NodeContext
 * @returns {number} -1, 0, or 1
 */


export var nodePathSortComparison = function nodePathSortComparison(a, b) {
  if (!a) return -1;
  if (!b) return 1;
  var keyA = getNodePathKey(a);
  var keyB = getNodePathKey(b);
  var longerLength = Math.max(keyA.length, keyB.length);

  for (var i = 0; i < longerLength; i += 1) {
    if (keyA[i] !== keyB[i]) {
      if (typeof keyA[i] === 'undefined') return -1;
      if (typeof keyB[i] === 'undefined') return 1;
      return keyA[i] > keyB[i] ? 1 : -1;
    }
  }

  return 0;
};
export var sortItemsByNodePath = function sortItemsByNodePath(itemsWithPath) {
  if (!Array.isArray(itemsWithPath)) throw new Error('itemsWithPath must be an array');
  var sorted = itemsWithPath.slice();
  sorted.sort(function (a, b) {
    return nodePathSortComparison(a.nodePath, b.nodePath);
  });
  return sorted;
};